import get from 'lodash.get'
import Vue from 'vue'
import vuetify from '@/plugins/vuetify'
import store from '@/store'

export const removeNumberFromArray = (array, key) => {
    if (!array.includes(key)) {
        return }
    array.splice(array.indexOf(key), 1)
}

export const removeNumbersFromArray = (array, keys) => {
    keys.forEach((key) => {
        array = removeNumberFromArray(array, key)
    })

  return array
}

export const getItemFromArray = (array, key) => {
    if (!array.includes(key)) {
        return false }

    return array[array.indexOf(key)]
}

export const getItemByFieldFromArray = (field, array, key) => {
    const tmp = array.map(item => item[field])
    console.log(tmp)
    if (!tmp.includes(key)) {
        return false }

    return array[tmp.indexOf(key)]
}

export const removeItemByFieldFromArray = (field, array, key) => {
    const tmp = array.map(item => item[field])
    console.log('r', tmp, key)
    if (!tmp.includes(key)) {
        return array
    }
    console.log('return')
    const item = array.splice(tmp.indexOf(key), 1)

    return item[0]
}

export const removeItemsByFieldFromArray = (field, array, keys) => {
    keys.forEach((key) => {
        array = removeItemByFieldFromArray(field, array, key)
    })

  return array
}

/**
 * Replaces or inserts data into an array by field
 *
 * @param field The field to search for
 * @param array The array to insert or replace into
 * @param data The data being inserted or replace
 */
export const replaceItemByFieldToArray = (field, array, data) => {
    const tmp = array.map(item => get(item, field))
    if (!tmp.includes(get(data,field))) {
        array.unshift(data)

        return
    }
    array.splice(tmp.indexOf(get(data,field)), 1, data)
}


export const stringToColour = (str) => {
    let hash = 0
    for (let i = 0; i < str.length; i++) {
        hash = str.charCodeAt(i) + ((hash << 5) - hash)
    }
    let colour = '#'
    for (let i = 0; i < 3; i++) {
        let value = (hash >> (i * 8)) & 0xFF
        colour += ('00' + value.toString(16)).substr(-2)
    }

    return colour
}

/**
 *
 * @param {object} component The vue component to launch
 * @param {object} props
 * @param {function} callback The callback on the components destroy
 * @returns {Promise<unknown>}
 */
export const programmaticVue = (component, props = {}, callback = (resolve) => {resolve()} ) => {
    const Ctor = Vue.extend(component)
    const container = document.querySelector('[data-app=true]') || document.body

    return new Promise(resolve => {
        const cmp = new Ctor({
            vuetify,
            store,
            propsData: props,
            beforeDestroy() {
                callback(resolve, cmp)
            },
            destroyed() {
                container.removeChild(cmp.$el)
            }
        })
    container.appendChild(cmp.$mount().$el)
    })
}

export const cleanGoogleAutocompleteData = (place) => {
    if (!place.address_components) {
        return null
    }
    const data = {}
    const addressComponents = {
        street_number: 'short_name',
        route: 'long_name',
        locality: 'long_name',
        administrative_area_level_1: 'short_name',
        administrative_area_level_2: 'short_name',
        country: 'long_name',
        postal_code: 'short_name'
    }

    for (let i = 0; i < place.address_components.length; i += 1) {
        let addressType = place.address_components[i].types[0]
        if (addressComponents[addressType]) {
            data[addressType] = place.address_components[i][addressComponents[addressType]]
        }
    }
    if (place.geometry) {
        data.latitude = place.geometry.location.lat()
        data.longitude = place.geometry.location.lng()
    }
    if (place.name) {
        data.name = place.name
    }
    if (place.photos) {
        data.photos = place.photos
    }
    if (place.place_id) {
        data.place_id = place.place_id
    }

    if (place.formatted_address) {
        data.formatted_address = place.formatted_address
    }

    return data
}
